import { chatsActions } from "../../actionTypes";

const initialState = {
	data: {},
	fetching: false,
	fetched: false,
	error: null,
};

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case chatsActions.REVEAL_USERS: {
			return { ...initialState, fetching: true };
		}

		case chatsActions.REVEAL_USERS_FULFILLED: {
			return {
				...state,
				fetching: false,
				fetched: true,
				data: action.payload,
			};
		}

		case chatsActions.REVEAL_USERS_REJECTED: {
			return { ...state, fetching: false, error: action.payload };
		}

		default:
	}

	return state;
};

export default Reducer;
